import { render, staticRenderFns } from "./CadastroPerfil.vue?vue&type=template&id=0c438718&scoped=true&"
import script from "./CadastroPerfil.vue?vue&type=script&lang=js&"
export * from "./CadastroPerfil.vue?vue&type=script&lang=js&"
import style0 from "./CadastroPerfil.vue?vue&type=style&index=0&id=0c438718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c438718",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VForm,VRow,VSheet,VSkeletonLoader,VTextField})
